<script setup lang="ts">
defineProps<{ offerId: string }>()
</script>

<template>
  <n-popover>
    <template #trigger>
      <slot />
    </template>
    <div>
      <OfferStatusTimeline :offer-id="offerId" horizontal />
    </div>
  </n-popover>
</template>
